// src/pages/MAEduPage.js
import React from 'react';
import Layout from '../components/Layout/Layout';
import maEduPdf from '../images/MA-EDUCATION.pdf';

const MAEduPage = () => {
  return (
    <Layout>
      <div id="ma-education" className="page-container" style={{ maxWidth: '1000px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        
        <div style={{ backgroundColor: '#222', border: '1px solid #111', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
          <h2 style={{ color: '#93c5fd', borderBottom: '2px solid #3b82f6', paddingBottom: '15px', marginBottom: '40px', textAlign: 'center', fontSize: '2.2rem', fontWeight: 'bold' }}>
            Science Departments Syllabus
          </h2>
          
          <div style={{ backgroundColor: '#111', borderLeft: '4px solid #3b82f6', padding: '10px', borderRadius: '4px' }}>
            <iframe 
              src={maEduPdf} 
              width="100%" 
              height="800px" 
              title="Science Departments Syllabus Document" 
              style={{ border: 'none', backgroundColor: '#333', borderRadius: '4px' }} 
            />
          </div>
        </div>

      </div>
    </Layout>
  );
};

export default MAEduPage;
